export const formControlSlotsHelperTextTypography = "400 0.75rem/1rem Inter";
export const formControlSlotsHelperTextFontWeight = "400";
export const formControlSlotsHelperTextColor = "#75859e";
export const formControlSlotsHelperTextResizingW = "resizing-w-fill";
export const formControlSlotsHelperTextResizingH = "resizing-h-hug";
export const formControlSlotsHelperTextTextOverflow = "truncate";
export const formControlSlotsBaseItemSpacing = "0.25rem";
export const formControlSlotsBaseLayout = "layout-column";
export const formControlSlotsBaseResizingW = "resizing-w-fixed";
export const formControlSlotsBaseResizingH = "resizing-h-hug";
export const formControlSlotsHelperTextWrapperResizingW = "resizing-w-fill";
export const formControlSlotsHelperTextWrapperResizingH = "resizing-h-hug";
export const formControlSlotsHelperTextWrapperTextOverflow = "truncate";
export const formControlVariantsSize56dpHelperTextTypography = "400 0.875rem/1.25rem Inter";
export const formControlVariantsInvalidTrueHelperTextColor = "#ac3036";
